import React, { useState, useEffect, Fragment } from 'react'
import { Box, TextField } from '@material-ui/core'

import { makeStyles, useTheme } from '@material-ui/core/styles'

const dartmouthGreenColor = '#2D7638'
const themeGreenColor = '#39CFBA'

const useStyles = makeStyles(theme => ({
	root: {
		'& .MuiInputLabel-outlined ': {
			//color: '#39CFBA',
			fontFamily: 'Roboto light,sans-serif'
		},
		'& .MuiInputLabel-formControl': {
			// color: '#39CFBA',
		},
		'& label.Mui-focused': {
			//color: themeGreenColor, *floating label color
		},
		'& .MuiInput-underline:after': {
			// borderBottomColor: dartmouthGreenColor,
		},
		'& $checked': {
			//color: '#62C370',
		},
		'& .MuiOutlinedInput-root': {
			borderRadius: '0px',
			'& fieldset': {
				//borderColor: themeGreenColor,
			},
			'&:hover fieldset': {
				//borderColor: themeGreenColor,
			},
			'&.Mui-focused fieldset': {
				//borderColor: mingColor, * when focus feild
			}
		}
	},

	hiddenText: {
		color: 'transparent'
	}
}))

export default function GoogleSearchInputBox(props) {
	const { name, label, value, type, error = null, onChange, onFocus, onClick, onBlur } = props
	const classes = useStyles()

	return (
		<Box className={classes.textWrapper}>
			<TextField
				className={classes.root}
				variant='outlined'
				size='medium'
				label={label}
				type={type}
				name={name}
				value={value}
				onChange={onChange}
				onFocus={onFocus}
				onBlur={onBlur}
				onClick={onClick}
				helperText={<span className={classes.hiddenText}>*</span>}
				{...(error && { error: true, helperText: error })}
			/>
		</Box>
	)
}
